import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const SalesSection = (props) =>
{

  return (

    <section id="sales-section" class="has-background-dark">
      <div class="columns">
        <div class="column is-half p-6">
          <section class="section is-medium">
            <div class="content" data-sal="slide-right"
              data-sal-delay="300"
              data-sal-easing="ease">
              <h1 class="title pb-5 mainfont has-text-white-ter" >{props.title}</h1>
              <div class="description mainfont is-size-5 has-text-white-ter" >
                <p>{props.description}</p>
              </div>
            </div>

          </section>
        </div >

        <div class="column is-half p-0 pb-3">
          <StaticImage
            src="../images/bandoldtimer.jpg"
            imgStyle={{ height: "100%", }}
            style={{ height: "100%" }}
            quality={100}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="Brand logo"
          />
        </div>
      </div >
    </section >
  )
}
export default SalesSection;